module.exports = __webpack_public_path__ + "img/shield-check.ca5e5c72.svg";